import {
  BarcodeOutlined,
  PercentageOutlined,
  ProductOutlined,
  UserOutlined,
} from '@ant-design/icons'
import { Spin } from 'antd'
import { ReactNode } from 'react'

import { useBoosterProgramOverview } from 'hooks/booster-program'

import BoosterEnrollmentChart from './chart/booster-enrollment-chart'

const formatNumber = (value: number) => new Intl.NumberFormat('en-US').format(value)

interface OverviewCard {
  label: string
  value: ReactNode
  icon: ReactNode
}

const BoosterOverviewSection = () => {
  const { overview, isLoading } = useBoosterProgramOverview()

  const cards: OverviewCard[] = [
    {
      label: 'Active/ Total Programs',
      value: `${formatNumber(overview.activePrograms)} / ${formatNumber(overview.totalPrograms)}`,
      icon: <ProductOutlined />,
    },
    {
      label: 'Active Enrolled Users',
      value: formatNumber(overview.activeEnrolledUsers),
      icon: <UserOutlined />,
    },
    {
      label: 'Codes Issued',
      value: formatNumber(overview.codesIssued),
      icon: <BarcodeOutlined />,
    },
    {
      label: 'Code Usage Rate',
      value: `${formatNumber(overview.codeUsageRate)}%`,
      icon: <PercentageOutlined />,
    },
  ]

  const renderCard = (card: OverviewCard) => (
    <div className="colum w-3" key={card.label}>
      <div className="guide-box">
        <div className="box-content">
          <div className="left-s">
            <div className="txt">{card.label}</div>
            <div className="number">{isLoading ? <Spin /> : card.value}</div>
          </div>
          <div className="right-s">
            <div className="icon">{card.icon}</div>
          </div>
        </div>
      </div>
    </div>
  )

  return (
    <div className="wrap-box">
      <div className="title">Booster Program Overview</div>
      <div className="wrap-columns flex-box">
        <div className="left-col">
          <div className="columns">
            <div className="top-row">{cards.slice(0, 2).map(renderCard)}</div>
            <div className="bot-row">{cards.slice(2, 4).map(renderCard)}</div>
          </div>
        </div>
        <div className="right-col">
          <div className="wrap-chart">
            <div className="chart-box">
              <div className="columns">
                <div className="colum w-4">
                  <div className="line-chart">
                    <div className="content-chart">
                      <div className="title">New enrollments</div>
                      <BoosterEnrollmentChart data={overview.newEnrollments} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BoosterOverviewSection
